export enum MapLayerTypeEnum {
  node = 'node',
  wms = 'wms',
  wmts = 'wmts',
  wfs = 'wfs'
};
